<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ modalTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-data-table
              :headers="filteredHeaders"
              :items="itemsList"
              :loading="tableLoading"
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageText: 'Rodyti po:',
                itemsPerPageAllText: 'visi',
                itemsPerPageOptions: itemsPerPageOptions,
              }"
              :hide-default-footer="hideFooter"
              :items-per-page="pageSize"
            >
              <template #top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label=""
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template #[`header.pazymetas`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  label=""
                  v-model="headerPazymetas"
                  @click.native.stop="checkAllPazymetas()"
                />
              </template>
              <template #[`item.pazymetas`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    label=" "
                    v-model="pazymetasList"
                    :checkValue="item.amn_id"
                    :key="item.amn_id"
                  />
                </div>
              </template>
              <template slot="loading">
                Kraunasi...
              </template>
              <template slot="no-results">
                Duomenų nėra
              </template>
              <template slot="no-data">
                Duomenų nėra
              </template>
              <template #[`footer.page-text`]="props">
                Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button primary @click.native.stop="submit()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'

export default {
  name: 'ModalAsmuoSelect',
  props: {
    value: Boolean,
    title: String,
    asmenys: Array,
    asmenysPazymeti: Array,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tableLoading: false,
      headerPazymetas: false,
      pazymetasList: [],
      showConfirm: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: ' ',
          align: 'start',
          sortable: false,
          value: 'pazymetas',
        },
        {
          text: 'Asmens kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
        },
        {
          text: 'Vardas Pavardė / Pavadinimas',
          align: 'start',
          value: 'asm_pavadinimas',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    modalTitle() {
      return this.title
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.pazymetasList = this.asmenysPazymeti
      this.headerPazymetas = this.asmenys.length == this.asmenysPazymeti.length
    },
    saveData() {
      this.$emit('savedData', this.pazymetasList)
      this.closeModal()
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    checkAllPazymetas() {
      this.pazymetasList = []
      if (this.headerPazymetas) {
        this.itemsList.forEach(item => {
          this.pazymetasList.push(item.amn_id)
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
